import React from "react";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";

const TeamToolbar = ({ searchValue, onSearchChange, onAddMember }) => (
  <div className="team-page__toolbar">
    <div className="team-page__search">
      <SearchOutlined className="team-page__search-icon" />
      <input
        className="team-page__search-input"
        placeholder="Search member"
        value={searchValue}
        onChange={(event) => onSearchChange(event.target.value)}
      />
    </div>
    <button className="team-page__add-button" onClick={onAddMember} type="button">
      <PlusOutlined />
      <span>Add Member</span>
    </button>
  </div>
);

export default TeamToolbar;
